import "./css/swiper-bundle.min.css";
import "./css/image-reveal.css";
import "./css/common.css";
import "./css/main.css";
import "./css/sub.css";
import "./css/responsive.css";


import gsap from "./js/plugins/gsap.min.js";
import ScrollToPlugin from "./js/plugins/ScrollToPlugin.min.js";
import ScrollTrigger from "./js/plugins/ScrollTrigger.min.js";
import imageReveal from "./js/plugins/image-reveal.js";
//import hangul from "./js/plugins/hangul.js";
import typeHangul from "./js/plugins/type-hangul.min.js";
import script from "./js/script.js";
